import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import uniqueId from 'lodash/uniqueId';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Popover } from '@cancercentrum/rcc-bootstrap';
import classnames from 'classnames';
const DEFAULT_TRIGGER = [
    'click'
];
const DEFAULT_PLACEMENT = 'top';
// This is needed when the icon is embedded in a <label>. Otherwise a click on the icon simply results in the input field gaining focus.
const defaultOnClick = (e)=>{
    document.body.click();
    e.stopPropagation();
    e.preventDefault();
};
// Förhindra inputs från att få focus-state då Explanation ligger inuti en label.
const defaultonMouseDown = (e)=>{
    document.body.click();
    e.stopPropagation();
    e.preventDefault();
};
export const Explanation = (props)=>{
    const { title, className, trigger = DEFAULT_TRIGGER, placement = DEFAULT_PLACEMENT, children, onClick = defaultOnClick, onMouseDown = defaultonMouseDown, style } = props;
    const [id] = useState(()=>{
        return props.id || uniqueId('Explanation_');
    });
    const tooltipOverlay = /*#__PURE__*/ _jsx(Popover, {
        id: id,
        title: title,
        className: classnames('explanation__popover', className),
        children: children
    });
    return /*#__PURE__*/ _jsx(OverlayTrigger, {
        // @ts-ignore TODO: Exportera typ för placement från rcc-bootstrap
        placement: placement,
        overlay: tooltipOverlay,
        trigger: trigger,
        rootClose: true,
        popperConfig: {
            strategy: 'fixed'
        },
        children: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
            className: "explanation__icon",
            icon: faInfoCircle,
            onClick: onClick,
            style: style,
            onMouseDown: onMouseDown
        })
    });
};
